import { Store } from 'pullstate';
import { PuzzleStoreBaseDefaults } from '../../../utils/types';
import { getZeroMatrix, PathwordStoreType } from '../Pathword/PathwordStore';

// duplicate of pathword store aside from puzzleSize

export const Pathword5x5Store = new Store<PathwordStoreType>({
  ...PuzzleStoreBaseDefaults,
  revealed: false,
  path: getZeroMatrix(5),
  lines: {},
  highlights: getZeroMatrix(5),
  pathLength: 0,
  pathHead: null,
  successAnimationGrid: getZeroMatrix(5),
  puzzleSize: 5,
  cluetext: [],
  vowelMatrix: [],
  solutionPath: [],
  solutionLines: {},
  almostThereIsOpen: false,
  hintLetters: [],
  enabledHints: [0, 2, 4, 6],
  initialEnabledHints: 4,
  hintPositions: {},
  hintsUsed: 0,
});